import { Messages } from "../../types/messages";
import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler, apiFetchNotOkHandler } from "../errorHandler";
import { getBuildVersion } from "../getDefaultHeaders";

export const sendSMS = async (
  bookingId: string,
  message: string
): Promise<Messages[] | undefined> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const paramsObj = {
    booking_id: `${bookingId}`,
    message
  };

  return await fetch(
    `${environmentVars?.COLLINS_API_BASE_URL}/bookings/${bookingId}/send-sms`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        ["Content-type"]: "application/json",
        "X-Build-Version": getBuildVersion()
      },
      body: JSON.stringify(paramsObj)
    }
  )
    .then(async (response) => {
      if (!response.ok) {
        apiFetchNotOkHandler(response, "Error sending SMS");
        return [];
      }

      return (await response.json()).payload?.messages ?? [];
    })
    .catch((error) => {
      errorHandler(error, "Error sending SMS");
      return [];
    });
};
